import { render, staticRenderFns } from "./OrderComponentV2.vue?vue&type=template&id=0895f774&scoped=true"
import script from "./OrderComponentV2.vue?vue&type=script&lang=js"
export * from "./OrderComponentV2.vue?vue&type=script&lang=js"
import style0 from "./OrderComponentV2.vue?vue&type=style&index=0&id=0895f774&prod&lang=scss"
import style1 from "./OrderComponentV2.vue?vue&type=style&index=1&id=0895f774&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0895f774",
  null
  
)

export default component.exports